import React, { PropTypes } from 'react';
import NavigationFullscreen from 'material-ui/svg-icons/navigation/fullscreen';
import NavigationFullscreenExit from 'material-ui/svg-icons/navigation/fullscreen-exit';

const FullscreenButton = ({ fullscreen, ...other }) => (
  fullscreen ?
    <NavigationFullscreenExit {...other} /> :
    <NavigationFullscreen {...other} />
);

FullscreenButton.propTypes = {
  fullscreen: PropTypes.bool.isRequired,
  onClick: React.PropTypes.func,
};

export default FullscreenButton;



// WEBPACK FOOTER //
// ./src/components/Map/FullscreenButton.js